<!-- eslint-disable -->
<template>
    <div style="text-align:left;">
        <div class="column-left">
            <SideNav />
        </div>
        <div>
            <div class="column-right">
                <TopNavClean />
                <div class="main-container">
                    <div v-if="loaded" class="professionals-container">
                        <!-- Header Section -->
                        <div class="page-header">
                            <div class="header-content">
                                <div class="title-section">
                                    <div class="page-icon" :style="{
                                        backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                                    }">
                                        <!-- SVG estilo ficha médica/paciente -->
                                        <!--
category: Document
tags: [document, file, add, new]
version: "1.49"
unicode: "efb2"
-->
                                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"
                                            viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.75"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                                            <path
                                                d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                                            <path d="M10 14h4" />
                                            <path d="M12 12v4" />
                                        </svg>

                                    </div>
                                    <div>
                                        <h1 class="page-title">Administrador de Cotizaciones</h1>
                                        <p class="page-subtitle">Admnistrar y Visualizar Cotizador {{ prestador.nombre
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="status-legend">
                            <div class="notion-filter">
                                <div>
                                    <label>Fecha inicio</label>
                                    <input type="date" v-model="startDate" />
                                </div>
                                <div>
                                    <label>Fecha fin</label>
                                    <input type="date" v-model="endDate" />
                                </div>
                                <div class="button-container">
                                    <button @click="applyDateFilter">Aplicar Filtros</button>
                                </div>
                                <div class="button-container">
                                    <button @click="showResumen = !showResumen">
                                        {{ showResumen ? 'Ocultar resumen' : 'Mostrar resumen' }}
                                    </button>
                                </div>
                            </div>

                            <div class="resumen-section" v-show="showResumen">
                                <!-- Primera fila: SOLO KPIs -->
                                <div class="resumen-kpi-scroll">
                                    <div class="resumen-kpi-row">
                                        <div class="resumen-card kpi-card kpi-small kpi-coral">
                                            <div class="kpi-icon">
                                                <!--
unicode: "fef7"
version: "3.5"
-->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"
                                                    viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.75"
                                                    stroke-linecap="round" stroke-linejoin="round">
                                                    <path
                                                        d="M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                                                    <path
                                                        d="M9 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                                                    <path
                                                        d="M15 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                                                    <path d="M4 20h14" />
                                                </svg>

                                            </div>
                                            <h3>Total Cotizaciones</h3>
                                            <p class="big-number">
                                                {{ pricesDataKPI.estadisticas &&
                                                    pricesDataKPI.estadisticas.total_cotizaciones || '—' }}
                                            </p>
                                        </div>

                                        <div class="resumen-card kpi-card kpi-small kpi-yellow">
                                            <div class="kpi-icon">

                                                <!--
tags: [money, earn, salary, change, dollar]
version: "1.3"
category: E-commerce
unicode: "eb82"
-->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"
                                                    viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.75"
                                                    stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                    <path
                                                        d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
                                                    <path d="M12 7v10" />
                                                </svg>



                                            </div>
                                            <h3>Monto Total Cotizado</h3>
                                            <p class="big-number">
                                                ${{ pricesDataKPI.estadisticas && pricesDataKPI.estadisticas.monto_total
                                                    ? pricesDataKPI.estadisticas.monto_total.toLocaleString('es-CL') : '—'
                                                }}
                                            </p>
                                            <p class="kpi-subtitle">CLP estimados</p>
                                        </div>

                                        <div class="resumen-card kpi-card kpi-wide kpi-lime">
                                            <div class="kpi-icon">
                                                <!--
tags: [doctor, medical, physician, test, examination, health, illness, sickness, scrutiny, hospital]
version: "1.33"
category: Health
unicode: "edbe"
-->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"
                                                    viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.75"
                                                    stroke-linecap="round" stroke-linejoin="round">
                                                    <path
                                                        d="M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1" />
                                                    <path d="M8 15a6 6 0 1 0 12 0v-3" />
                                                    <path d="M11 3v2" />
                                                    <path d="M6 3v2" />
                                                    <path d="M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                </svg>
                                            </div>
                                            <h3>Examen Más Cotizado</h3>
                                            <p class="big-number exam-name">
                                                {{ pricesDataKPI.estadisticas &&
                                                    pricesDataKPI.estadisticas.examen_mas_cotizado || '—' }}
                                            </p>
                                            <p class="kpi-subtitle">IGE ESPECÍFICA RYE GRASS-CENTENO</p>
                                            <p class="kpi-description">Top examen por número de cotizaciones</p>
                                        </div>

                                        <div class="resumen-card kpi-card kpi-wide kpi-blue">
                                            <div class="kpi-icon">
                                                <!--
tags: [doctor, sickness, illness, nurse, medication, emergency, treat, surgery]
category: Buildings
version: "1.1"
unicode: "ea4d"
-->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"
                                                    viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.75"
                                                    stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M3 21l18 0" />
                                                    <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
                                                    <path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" />
                                                    <path d="M10 9l4 0" />
                                                    <path d="M12 7l0 4" />
                                                </svg>



                                            </div>
                                            <h3>Sucursal Más Seleccionada</h3>
                                            <p class="big-number">
                                                {{ pricesDataKPI.estadisticas &&
                                                    pricesDataKPI.estadisticas.sucursal_mas_seleccionada || '—' }}
                                            </p>
                                        </div>

                                        <div class="resumen-card kpi-card kpi-wide kpi-purple">
                                            <div class="kpi-icon">

                                                <!--
category: System
tags: [safety, protect, protection, "yes", add]
version: "1.0"
unicode: "eb22"
-->
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"
                                                    viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.75"
                                                    stroke-linecap="round" stroke-linejoin="round">
                                                    <path
                                                        d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06" />
                                                    <path d="M15 19l2 2l4 -4" />
                                                </svg>

                                            </div>
                                            <h3>Previsión Más Común</h3>
                                            <p class="big-number">
                                                {{ pricesDataKPI.estadisticas &&
                                                    pricesDataKPI.estadisticas.prevision_mas_comun || '—' }}
                                            </p>
                                            <p class="kpi-subtitle">Cruz Blanca</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Segunda fila: Listados -->
                                <div class="resumen-lists-row">
                                    <div class="resumen-card resumen-list ranking-card">
                                        <div class="list-header">
                                            <div class="list-icon">
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12" cy="8" r="5" stroke="currentColor"
                                                        stroke-width="2" />
                                                    <path d="M20 21a8 8 0 1 0-16 0" stroke="currentColor"
                                                        stroke-width="2" />
                                                    <path d="M16 11l2 2 4-4" stroke="currentColor" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <h3>Ranking de Exámenes Cotizados</h3>
                                        </div>
                                        <ul class="ranking-list">
                                            <li v-for="(count, exam) in (pricesDataKPI.estadisticas && pricesDataKPI.estadisticas.top_5_examenes) || {}"
                                                :key="exam">
                                                <span class="exam-name">{{ exam }}</span>
                                                <span class="exam-count">{{ count }}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="resumen-card resumen-list users-card">
                                        <div class="list-header">
                                            <div class="list-icon">
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                                                        stroke="currentColor" stroke-width="2" />
                                                    <circle cx="9" cy="7" r="4" stroke="currentColor"
                                                        stroke-width="2" />
                                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor"
                                                        stroke-width="2" />
                                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor"
                                                        stroke-width="2" />
                                                </svg>
                                            </div>
                                            <h3>Ranking de Usuarios Cotizantes</h3>
                                        </div>
                                        <div class="table-container">
                                            <table class="users-table">
                                                <thead>
                                                    <tr>
                                                        <th>Nombre</th>
                                                        <th>RUT</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="c in top_cliente" :key="c.rut">
                                                        <td class="user-name">{{ c.nombre }}</td>
                                                        <td class="user-rut">{{ c.rut }}</td>
                                                        <td class="user-total">{{ c.total_cotizaciones }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <!-- HISTORIAL -->
                        <div class="historial-info">
                            <h2 class="text-xl font-bold mb-4">Historial de Cotizaciones</h2>


                            <div class="notion-toolbar">
                                <button class="btn-refresh"
                                    :style="{ background: `${prestador.admin.assets.colors.primary}` }"
                                    @click="abrirModalDescarga">
                                    📥 Descargar Cotizaciones
                                </button>

                                <!-- <div class="search-container">
                                    <div class="search-input-wrapper">
                                        <div class="search-icon">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                                                    stroke="#64748b" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <input class="search-input" type="text" v-model="searchQueryCotizaciones"
                                            placeholder="Buscar cliente o examen" />
                                    </div>
                                </div> -->
                            </div>

                            <!-- 📋 Tabla -->
                            <div class="schedule-table-container">
                                <table class="schedule-table">
                                    <thead class="bg-gray-100">
                                        <tr>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('id')">
                                                ID
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer"
                                                @click="sortBy('created_at')">
                                                Fecha
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('sucursal')">
                                                Sucursal
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('prevision')">
                                                Previsión
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('nombre')">
                                                Nombre
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('rut')">
                                                Rut
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('email')">
                                                Email
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('email')">
                                                Teléfono
                                            </th>
                                            <th class="px-4 py-2 text-left cursor-pointer" @click="sortBy('examen')">
                                                Exámenes
                                            </th>
                                            <th class="px-4 py-2 text-right cursor-pointer"
                                                @click="sortBy('total_cotizacion')">
                                                Total
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="p in cotizaciones" :key="p.id" class="border-t hover:bg-gray-50">
                                            <td class="px-4 py-2">{{ p.id }}</td>
                                            <td class="px-4 py-2">{{ formatDate(p.created_at) }}</td>
                                            <td class="px-4 py-2">{{ p.sucursal }}</td>
                                            <td class="px-4 py-2">{{ p.prevision }}</td>
                                            <td class="px-4 py-2">
                                                <ul>
                                                    <li v-for="c in p.clientes" :key="c.id">
                                                        {{ c.nombre }} ({{ c.rut }})
                                                    </li>
                                                </ul>
                                            </td>
                                            <td class="px-4 py-2">
                                                <ul>
                                                    <li v-for="c in p.clientes" :key="c.id">
                                                        {{ c.rut }}
                                                    </li>
                                                </ul>
                                            </td>
                                            <td class="px-4 py-2">
                                                <ul>
                                                    <li v-for="c in p.clientes" :key="c.id">
                                                        {{ c.email }}
                                                    </li>
                                                </ul>
                                            </td>
                                            <td class="px-4 py-2">
                                                <ul>
                                                    <li v-for="c in p.clientes" :key="c.id">
                                                        {{ c.telefono }}
                                                    </li>
                                                </ul>
                                            </td>
                                            <td class="px-4 py-2">
                                                <ul>
                                                    <li v-for="(ex, i) in p.examen" :key="i">
                                                        {{ ex.nombre }} - ${{ ex.precio }}
                                                    </li>
                                                </ul>
                                            </td>
                                            <td class="px-4 py-2 text-right font-bold">
                                                ${{ p.total_cotizacion }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- 🔄 Paginación mejorada -->
                            <div class="flex justify-between items-center mt-4">
                                <div class="text-sm text-gray-600">
                                    Mostrando {{ paginationInfo.per_page }} de {{ paginationInfo.total_records }}
                                    registros
                                </div>

                                <div class="flex space-x-2">
                                    <button class="px-3 py-1 border rounded disabled:opacity-50"
                                        :disabled="!paginationInfo.has_prev"
                                        @click="goToPage(paginationInfo.current_page - 1)">
                                        Anterior
                                    </button>

                                    <span class="px-2 py-1">
                                        Página {{ paginationInfo.current_page }} de {{ paginationInfo.total_pages }}
                                    </span>

                                    <button class="px-3 py-1 border rounded disabled:opacity-50"
                                        :disabled="!paginationInfo.has_next"
                                        @click="goToPage(paginationInfo.current_page + 1)">
                                        Siguiente
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div v-if="mostrarModalDescarga" class="modal-overlay">
                            <div class="modal-content">
                                <h2>Descargar Cotizaciones</h2>
                                <p>Selecciona el rango de fechas para descargar las cotizaciones en formato CSV o .xlsx.</p>

                                <div class="notion-filter">
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Fecha inicio</label>
                                        <input type="date" v-model="fechaInicioDescarga"
                                            class="border rounded px-3 py-2 w-full">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Fecha fin</label>
                                        <input type="date" v-model="fechaFinDescarga"
                                            class="border rounded px-3 py-2 w-full">
                                    </div>
                                </div>

                                <div class="modal-actions">
                                    <button class="btn-refresh" :style="{
                                        background: `${prestador.admin.assets.colors.primary}`
                                    }" @click="descargarCotizaciones"
                                        :disabled="!fechaInicioDescarga || !fechaFinDescarga">
                                        📥 Descargar
                                    </button>
                                    <button class="btn-refresh" :style="{
                                        background: '#6b7280'
                                    }" @click="mostrarModalDescarga = false">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>


                        <!-- PRECIOS -->
                        <div class="historial-info">
                            <section class="notion-section">
                                <h2 class="section-title">Exámenes y Precios</h2>
                                <div class="button-group">
                                    <button class="btn-refresh"
                                        :style="{ background: `${prestador.admin.assets.colors.primary}` }"
                                        @click="descargarComoExcel(prestador.atributos.config.cotizador_s3)">
                                        Descargar Base de Datos (Excel)
                                    </button>

                                    <button class="btn-refresh" :style="{
                                        backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                                    }" @click="mostrarModal = true">
                                        Subir nueva Base de Datos
                                    </button>
                                </div>

                                <!-- Modal -->
                                <div v-if="mostrarModal" class="modal-overlay">
                                    <div class="modal-content">
                                        <h3 class="modal-title">Subir nueva base de datos</h3>
                                        <p class="modal-text">
                                            Se aceptan archivos <strong>.xlsx o .csv</strong> con la estructura de
                                            precios.
                                            Los archivos Excel se convertirán automáticamente a CSV.
                                        </p>

                                        <a class="btn-refresh mb-3"
                                            :style="{ background: `${prestador.admin.assets.colors.primary}` }"
                                            href="https://assets-prestador-clinicgo.s3.sa-east-1.amazonaws.com/13/public/archivo_base_ejemplo.xlsx"
                                            download>
                                            📥 Descargar archivo ejemplo
                                        </a>

                                        <input class="file-input mb-4" type="file" accept=".xlsx,.csv"
                                            @change="handleArchivo" />

                                        <div class="modal-actions">
                                            <button class="btn-refresh"
                                                :style="{ background: `${prestador.admin.assets.colors.primary}` }"
                                                @click="subirArchivo" :disabled="!archivoSeleccionado">
                                                📤 Subir Archivo
                                            </button>
                                            <button class="btn-refresh" :style="{ background: '#6b7280' }"
                                                @click="cerrarModal">
                                                ❌ Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div class="notion-toolbar">
                                <div class="search-container">
                                    <!-- Selector de Sucursal -->
                                    <div class="mb-3 md:mb-4">
                                        <select class="select-input" v-model="filtroSucursal">
                                            <option value="">Todas</option>
                                            <option v-for="s in sucursales" :key="s" :value="s">
                                                {{ s }}
                                            </option>
                                        </select>
                                    </div>

                                    <!-- Buscador -->
                                    <div class="search-input-wrapper">
                                        <div class="search-icon">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                                                    stroke="#64748b" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <input class="search-input" type="text" v-model="searchQuery"
                                            placeholder="Ej: ECOCARDIOGRAMA o 1701045" />
                                    </div>
                                </div>
                            </div>

                            <div class="schedule-table-container">
                                <table class="schedule-table">
                                    <thead class="bg-gray-100">
                                        <tr>
                                            <th class="px-4 py-2 text-left">Categoría</th>
                                            <th class="px-4 py-2 text-left">Código Fonasa</th>
                                            <th class="px-4 py-2 text-left">Prestación</th>
                                            <th class="px-4 py-2 text-left">Sucursal</th>
                                            <th class="px-4 py-2 text-right">Particular</th>
                                            <th class="px-4 py-2 text-right">Fonasa</th>
                                            <th class="px-4 py-2 text-right">Colmena</th>
                                            <th class="px-4 py-2 text-right">Cruz Blanca</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(exam, index) in datosPaginados" :key="index" class="border-t">
                                            <td class="px-4 py-2">{{ exam['Categoria'] }}</td>
                                            <td class="px-4 py-2">{{ exam['CódigoFonasa'] }}</td>
                                            <td class="px-4 py-2">{{ exam['Prestación'] }}</td>
                                            <td class="px-4 py-2">{{ exam['Sucursal'] }}</td>
                                            <td class="px-4 py-2 text-right">{{ exam['Particular'] }}</td>
                                            <td class="px-4 py-2 text-right">{{ exam['Copago Fonasa'] }}</td>
                                            <td class="px-4 py-2 text-right">{{ exam['Colmena'] }}</td>
                                            <td class="px-4 py-2 text-right">{{ exam['Cruz Blanca'] }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Controles de paginación -->
                            <div class="flex justify-center mt-4 space-x-2">
                                <button class="px-3 py-1 border rounded" :disabled="currentPage === 1"
                                    @click="currentPage--">
                                    Anterior
                                </button>

                                <span class="px-2 py-1">
                                    Página {{ currentPage }} de {{ totalPages }}
                                </span>

                                <button class="px-3 py-1 border rounded" :disabled="currentPage === totalPages"
                                    @click="currentPage++">
                                    Siguiente
                                </button>
                            </div>
                        </div>

                    </div>

                    <!-- Loading State -->
                    <div v-else class="loading-container">
                        <div class="loading-content">
                            <Loader :height="100" :width="100" />
                            <h3>Cargando dashboard...</h3>
                            <p>Por favor espere mientras cargamos la información</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */

import { mapGetters } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNavClean from './TopNavClean.vue';
import axios from 'axios';
import Papa from 'papaparse'
import * as XLSX from 'xlsx';

export default {
    name: 'Cotizador',
    components: {
        SideNav,
        Loader,
        TopNavClean
    },
    data() {
        const hoy = new Date();
        const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        const ultimoDia = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
        const fmt = (d) => d.toISOString().slice(0, 10);
        return {
            loaded: true,
            mostrarModal: false,
            archivoSeleccionado: null,
            showResumen: true,
            data: [],
            pricesData: [],
            pricesDataKPI: [],
            currentPage: 1,
            perPage: 10,
            filtroSucursal: '',
            searchQuery: '',

            cotizaciones: [],

            currentPageCotizaciones: 1,
            perPageCotizaciones: 5,
            searchQueryCotizaciones: "",

            startDate: fmt(primerDia),
            endDate: fmt(ultimoDia),
            paginationInfo: {
                current_page: 1,
                per_page: 5,
                total_records: 0,
                total_pages: 1,
                has_next: false,
                has_prev: false
            },

            mostrarModalDescarga: false,
            fechaInicioDescarga: '',
            fechaFinDescarga: '',

            sortKey: '',
            sortAsc: true,

            columnasRequeridas: [
                'Categoria', 'CódigoFonasa', 'Prestación', 'Sucursal', 'Particular',
                'Copago Fonasa', 'Colmena', 'Cruz Blanca', 'Banmédica / Vida Tres',
                'Consalud', 'Nueva Mas Vida', 'Keywords'
            ],
        }
    },
    computed: {
        ...mapGetters(['prestador']),

        sucursales() {
            const set = new Set(this.data.map((d) => d['Sucursal']).filter(Boolean))
            return Array.from(set).sort()
        },

        examenes() {
            const set = new Set(this.data.map((d) => d['Prestación']).filter(Boolean))
            return Array.from(set).sort()
        },

        datosFiltrados() {
            return this.data.filter((d) => {
                const matchSucursal = this.filtroSucursal ? d['Sucursal'] === this.filtroSucursal : true
                const query = this.searchQuery.toLowerCase()

                const matchBusqueda =
                    !query ||
                    d['Prestación']?.toLowerCase().includes(query) ||
                    d['Código Fonasa']?.toLowerCase().includes(query)

                return matchSucursal && matchBusqueda
            })
        },

        totalPages() {
            return Math.ceil(this.datosFiltrados.length / this.perPage)
        },

        datosPaginados() {
            const start = (this.currentPage - 1) * this.perPage
            return this.datosFiltrados.slice(start, start + this.perPage)
        },

        kpis() {
            return this.pricesDataKPI?.estadisticas || {}
        },

        top_cliente() {
            return this.pricesDataKPI?.estadisticas?.top_5_clientes || []
        }
    },
    methods: {
        abrirModalDescarga() {
            this.fechaInicioDescarga = this.startDate || '';
            this.fechaFinDescarga = this.endDate || '';
            this.mostrarModalDescarga = true;
        },

        sortBy(key) {
            if (this.sortKey === key) {
                this.sortAsc = !this.sortAsc
            } else {
                this.sortKey = key
                this.sortAsc = true
            }

            this.cotizaciones.sort((a, b) => {
                let x = a[key]
                let y = b[key]

                if (key === 'created_at') {
                    x = new Date(x)
                    y = new Date(y)
                }

                if (typeof x === 'string') x = x.toLowerCase()
                if (typeof y === 'string') y = y.toLowerCase()

                if (x < y) return this.sortAsc ? -1 : 1
                if (x > y) return this.sortAsc ? 1 : -1
                return 0
            })
        },

        descargarCotizaciones() {

            if (!this.fechaInicioDescarga || !this.fechaFinDescarga) {
                this.$notify({
                    group: 'foo',
                    title: 'Por favor, selecciona un rango de fechas para descargar!',
                    text: 'Ingrese una fecha válida',
                    type: 'warning'
                });
                return;
            }

            if (new Date(this.fechaInicioDescarga) > new Date(this.fechaFinDescarga)) {
                this.$notify({
                    group: 'foo',
                    title: 'La fecha de inicio no puede ser mayor que la fecha fin',
                    text: 'Ingrese una fecha válida',
                    type: 'error'
                });
                return;
            }

            const params = {
                start_date: this.fechaInicioDescarga,
                end_date: this.fechaFinDescarga
            };

            this.loaded = false;

            axios({
                url: window.hostname + "/api/admin/cotizaciones/descargar",
                method: 'GET',
                params: params,
                responseType: 'blob'
            })
                .then(response => {
                    if (response.data instanceof Blob) {
                        const url = window.URL.createObjectURL(response.data);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `cotizaciones_${this.fechaInicioDescarga}_${this.fechaFinDescarga}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);

                        this.mostrarModalDescarga = false;
                    } else {
                        this.$notify({
                            group: 'foo',
                            title: 'No se pudo generar el archivo de descarga',
                            text: 'Por favor intente más tarde',
                            type: 'error'
                        });
                    }
                    this.loaded = true;
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        this.$notify({
                            group: 'foo',
                            title: 'No se encontraron cotizaciones para el rango de fechas seleccionado',
                            text: 'Ingrese una fecha válida',
                            type: 'warning'
                        });
                    } else if (error.response && error.response.status === 400) {
                        this.$notify({
                            group: 'foo',
                            title: 'Formato de fechas inválido',
                            text: 'Ingrese una fecha válida',
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            group: 'foo',
                            title: 'Error al descargar las cotizaciones. Verifica la consola para más detalles.',
                            text: 'Ingrese una fecha válida',
                            type: 'error'
                        });
                    }
                    this.loaded = true;
                });
        },

        descargarComoExcel() {
            if (!this.prestador || !this.prestador.atributos || !this.prestador.atributos.config || !this.prestador.atributos.config.cotizador_s3) {
                console.error('prestador o la URL no están definidos');
                this.$notify({
                    group: 'foo',
                    title: 'Error de configuración',
                    text: 'No se pudo encontrar la URL del archivo',
                    type: 'error'
                });
                return;
            }

            const csvUrl = this.prestador.atributos.config.cotizador_s3;

            axios({
                url: csvUrl,
                method: 'GET',
                responseType: 'text'
            })
                .then(response => {
                    const workbook = XLSX.read(response.data, { type: 'string' });

                    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                    const blob = new Blob([excelBuffer], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'base_de_datos_precios.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);

                    this.$notify({
                        group: 'foo',
                        title: 'Descarga completada',
                        text: 'El archivo Excel se ha generado correctamente',
                        type: 'success'
                    });
                })
                .catch(error => {
                    console.error('Error al descargar:', error);
                    this.$notify({
                        group: 'foo',
                        title: 'Error al convertir el archivo',
                        text: 'Intente nuevamente',
                        type: 'error'
                    });
                });
        },
        handleArchivo(event) {
            this.archivoSeleccionado = event.target.files[0];
        },
        getPrices() {
            const params = {
                page: this.currentPageCotizaciones,
                per_page: this.perPageCotizaciones
            };

            if (this.startDate) {
                params.start_date = this.startDate;
            }
            if (this.endDate) {
                params.end_date = this.endDate;
            }

            axios({
                url: window.hostname + "/api/admin/cotizaciones",
                method: "GET",
                params: params
            })
                .then((r) => {
                    this.cotizaciones = r.data.data;
                    this.paginationInfo = r.data.pagination;
                    this.$notify({
                        group: 'foo',
                        title: 'Carga completa',
                        text: 'Revisar cotizaciones',
                        type: 'success'
                    });
                })
                .catch((error) => {
                    this.$notify({
                        group: 'foo',
                        title: 'Error de servidor',
                        text: 'Por favor intente más tarde',
                        type: 'error'
                    });
                });
        },
        getPricesKPI() {
            this.loaded = false;
            const params = {};

            if (this.startDate) {
                params.start_date = this.startDate;
            }
            if (this.endDate) {
                params.end_date = this.endDate;
            }

            axios({
                url: window.hostname + '/api/cotizaciones/estadisticas',
                method: 'GET',
                params: params
            })
                .then((r) => {
                    this.pricesDataKPI = r.data;
                    this.loaded = true;
                })
                .catch((error) => {
                    this.loaded = true;
                    this.$notify({
                        group: 'foo',
                        title: 'Error de servidor',
                        text: 'Por favor intente más tarde',
                        type: 'error'
                    });
                })
        },
        formatDate(date) {
            return new Date(date).toLocaleString("es-CL");
        },
        applyDateFilter() {
            this.currentPageCotizaciones = 1;
            this.getPrices();
            this.getPricesKPI();
        },
        goToPage(page) {
            this.currentPageCotizaciones = page;
            this.getPrices();
        },
        async subirArchivo() {
            if (!this.archivoSeleccionado) return;

            const filename = this.archivoSeleccionado.name.toLowerCase();
            const esExcel = filename.endsWith('.xlsx');
            const esCSV = filename.endsWith('.csv');

            if (!esExcel && !esCSV) {
                this.$notify({
                    group: 'foo',
                    title: 'Formato inválido',
                    text: 'Solo se permiten archivos .csv o .xlsx',
                    type: 'error'
                });
                return;
            }

            let archivoParaSubir = this.archivoSeleccionado;

            if (esExcel) {
                try {
                    archivoParaSubir = await this.convertirExcelACsv(this.archivoSeleccionado);
                } catch (error) {
                    this.$notify({
                        group: 'foo',
                        title: 'Error al convertir Excel',
                        text: error.message,
                        type: 'error'
                    });
                    return;
                }
            }

            const formData = new FormData();
            formData.append("file", archivoParaSubir);

            try {
                const resp = await axios.post(
                    `${window.hostname}/api/prestadores/${this.prestador.id}/archivo`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Authorization": `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                this.$notify({
                    group: 'foo',
                    title: 'Archivo subido correctamente',
                    text: esExcel ? 'Excel convertido a CSV y subido' : 'CSV subido correctamente',
                    type: 'success'
                });

                this.cerrarModal();
                await this.loadCsv();
            } catch (err) {
                console.error('Error:', err);
                if (err.response && err.response.data && err.response.data.error) {
                    this.$notify({
                        group: 'foo',
                        title: 'Error al subir archivo',
                        text: err.response.data.error,
                        type: 'error'
                    });
                } else {
                    this.$notify({
                        group: 'foo',
                        title: 'Error de servidor',
                        text: 'Por favor intente más tarde',
                        type: 'error'
                    });
                }
            }
        },

        async convertirExcelACsv(archivoExcel) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                    try {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });

                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];

                        const csvContent = XLSX.utils.sheet_to_csv(worksheet);

                        const blob = new Blob([csvContent], { type: 'text/csv' });
                        const archivoCSV = new File([blob], 'archivo_convertido.csv', { type: 'text/csv' });

                        resolve(archivoCSV);

                    } catch (error) {
                        reject(new Error(`Error al procesar Excel: ${error.message}`));
                    }
                };

                reader.onerror = () => {
                    reject(new Error('Error al leer el archivo Excel'));
                };

                reader.readAsArrayBuffer(archivoExcel);
            });
        },

        handleArchivo(event) {
            this.archivoSeleccionado = event.target.files[0];

            if (this.archivoSeleccionado) {
                const filename = this.archivoSeleccionado.name.toLowerCase();
            }
        },
        cerrarModal() {
            this.mostrarModal = false;
            this.archivoSeleccionado = null;
        },
        async loadCsv() {
            this.loaded = false;

            const cotizador_route = this.prestador.atributos.config.cotizador_s3;

            try {
                const response = await fetch(cotizador_route)
                const csvText = await response.text()

                Papa.parse(csvText, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        this.processData(results.data)
                        this.cargando = false
                    },
                    error: (error) => {
                        console.error('Error al cargar el CSV:', error)
                        this.cargando = false
                    }
                })

                this.loaded = true;
            } catch (error) {
                console.error('Error al cargar el archivo:', error)
                this.loaded = true;
            }
        },
        processData(data) {
            this.data = data.map((row) => {
                const cleaned = {}
                Object.keys(row).forEach((key) => {
                    let value = row[key]?.toString().trim() || ''

                    if (/\$/.test(value)) {
                        value = value.replace(/\$/g, '').replace(/,/g, '').trim()
                    }

                    if (key.trim() === 'Código Fonasa') {
                        value = value.replace(/\s/g, '')
                    }

                    cleaned[key.trim()] = value
                })
                return cleaned
            })
        }

    },
    async mounted() {
        await this.loadCsv();
        await this.getPrices();
        await this.getPricesKPI();
    }
}
</script>


<style scoped>
.notion-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
    background: rgba(255, 255, 255, 0.7);
    padding: 1rem;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.notion-filter label {
    display: block;
    font-size: 0.9rem;
    font-weight: 500;
    color: #333;
    margin-bottom: 0.25rem;
}

.notion-filter input[type="date"] {
    width: 160px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background-color: #fff;
    font-size: 0.95rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.notion-filter input[type="date"]:focus {
    outline: none;
    border-color: #a8a8a8;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.notion-filter .button-container {
    align-self: flex-end;
}

.notion-filter button {
    background-color: #f3f3f3;
    color: #111;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background-color 0.2s, box-shadow 0.2s;
}

.notion-filter button:hover {
    background-color: #eaeaea;
}

.notion-filter button:active {
    background-color: #dddddd;
}

.column-right {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding-top: 0px;
    padding-left: 275px;
    width: 100%;
    min-height: 100vh;
}

.main-container {
    padding: 20px;
}

.historial-info {
    background: white;
    border-radius: 16px;
    padding: 0.5rem;
    margin-bottom: 2rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    display: grid;
}

.status-legend {
    background-color: #f8fafc;
    border: 2px solid #e2e8f0;
    border-radius: 16px;
    padding: 1rem;
    margin-bottom: 1rem;
    width: 100%;
}

/* Contenedor principal */
.resumen-section {
    padding: 1.5rem;
    background-color: #f8fafc;
}

/* FILA 1: KPIs */
.resumen-kpi-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 1rem;
    margin-bottom: 2rem;
}

.resumen-kpi-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
    min-width: 100%;
}

/* Tarjetas base */
.resumen-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 2rem;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -2px rgb(0 0 0 / 0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.resumen-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 10px 10px -5px rgb(0 0 0 / 0.04);
}

/* Iconos de KPI */
.kpi-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 1rem;
    opacity: 0.9;
}

.kpi-icon svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
}

.icon-white {
    color: white
}

/* Títulos de KPI */
.kpi-card h3 {
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    line-height: 1.4;
    opacity: 0.95;
}

/* Números grandes */
.big-number {
    color: #ffffff;
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 0.25rem;
}

/* Subtítulos y descripciones */
.kpi-subtitle {
    color: #ffffff;
    font-size: 0.75rem;
    font-weight: 500;
    opacity: 0.8;
    margin-bottom: 0.25rem;
}

.kpi-description {
    color: #ffffff;
    font-size: 0.75rem;
    opacity: 0.7;
    line-height: 1.3;
}

/* Nombre de examen especial */
.exam-name {
    font-size: 1.5rem !important;
    font-weight: 600;
    line-height: 1.2;
}

/* Colores de KPI */
.kpi-coral {
    background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
}

.kpi-yellow {
    background: linear-gradient(135deg, #ffd93d, #ffe066);
}

.kpi-lime {
    background: linear-gradient(135deg, #6bcf7f, #8dd99c);
}

.kpi-blue {
    background: linear-gradient(135deg, #4dabf7, #74c0fc);
}

.kpi-purple {
    background: linear-gradient(135deg, #9775fa, #b197fc);
}

/* FILA 2: Listas */
.resumen-lists-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 1.5rem;
}

/* Tarjetas de lista */
.resumen-list {
    background: #ffffff;
    color: #1f2937;
    padding: 1.5rem;
}

.list-header {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #f3f4f6;
}

.list-icon {
    width: 32px;
    height: 32px;
    margin-right: 0.75rem;
    color: #4dabf7;
}

.list-header h3 {
    color: #1f2937;
    font-size: 1.125rem;
    font-weight: 700;
    margin: 0;
}

/* Lista de ranking */
.ranking-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.ranking-list li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f3f4f6;
}

.ranking-list li:last-child {
    border-bottom: none;
}

.ranking-list .exam-name {
    font-weight: 500;
    color: #1f2937;
    flex: 1;
    margin-right: 1rem;
    font-size: 0.875rem !important;
}

.ranking-list .exam-count {
    font-weight: 700;
    color: #4dabf7;
    background: #f8fafc;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.875rem;
}

/* Tabla de usuarios */
.table-container {
    overflow-x: auto;
}

.users-table {
    width: 100%;
    border-collapse: collapse;
}

.users-table th {
    background: #f8fafc;
    color: #6b7280;
    font-weight: 600;
    font-size: 0.875rem;
    padding: 0.75rem;
    text-align: left;
    border-bottom: 2px solid #f3f4f6;
}

.users-table td {
    padding: 0.75rem;
    border-bottom: 1px solid #f3f4f6;
}

.users-table tr:hover {
    background: #f8fafc;
}

.user-name {
    font-weight: 500;
    color: #1f2937;
}

.user-rut {
    color: #6b7280;
    font-family: monospace;
    font-size: 0.875rem;
}

.user-total {
    font-weight: 700;
    color: #4dabf7;
    text-align: right;
}

/* Responsividad */
@media (max-width: 768px) {
    .resumen-section {
        padding: 1rem;
    }

    .resumen-kpi-row {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1rem;
    }

    .resumen-lists-row {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .resumen-card {
        padding: 1.5rem;
    }

    .big-number {
        font-size: 1.875rem;
    }

    .kpi-card h3 {
        font-size: 0.8rem;
    }
}

@media (max-width: 480px) {
    .resumen-kpi-row {
        grid-template-columns: 1fr;
    }

    .resumen-card {
        padding: 1.25rem;
    }

    .big-number {
        font-size: 1.5rem;
    }

    .users-table {
        font-size: 0.875rem;
    }

    .users-table th,
    .users-table td {
        padding: 0.5rem;
    }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce) {
    .resumen-card {
        transition: none;
    }

    .resumen-card:hover {
        transform: none;
    }
}

/* Focus para navegación por teclado */
.resumen-card:focus-within {
    outline: 2px solid #4dabf7;
    outline-offset: 2px;
}

/* Alto contraste para accesibilidad */
@media (prefers-contrast: high) {

    .kpi-subtitle,
    .kpi-description {
        opacity: 1;
    }

    .kpi-icon {
        opacity: 1;
    }
}

/* Lista (estilo limpio)
.resumen-list {
    background: white;
    color: #1f2937;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    text-align: left;
}

.resumen-list h3 {
    color: #111827;
    margin-bottom: 0.8rem;
}

.resumen-list ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.resumen-list li {
    padding: 0.3rem 0;
    border-bottom: 1px solid #f3f4f6;
}

.resumen-list li:last-child {
    border-bottom: none;
} */

.search-input-wrapper {
    position: relative;
    display: flex;
    gap: 0.75rem;
    background-color: #f8fafc;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    padding: 0.5rem 1rem 0.5rem 2.75rem;
    margin-top: .5rem;
}

.search-input-wrapper-input {
    background: transparent;
}

/* .search-icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
} */

.schedule-table-container {
    overflow-x: auto;
}

.schedule-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 8px;
    overflow: hidden;
}

.schedule-table th {
    background: #f8fafc;
    padding: 1rem;
    text-align: left;
    font-weight: 600;
    color: #64748b;
    font-size: 0.875rem;
    border-bottom: 1px solid #e2e8f0;
}

.schedule-table td {
    padding: 1rem;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: top;
}

.schedule-row:hover {
    background-color: #f8fafc;
}

.professionals-container {
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.page-header {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 2rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 2rem;
}

.title-section {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.page-icon {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 0.5rem;
    letter-spacing: -0.025em;
}

.page-subtitle {
    font-size: 1.125rem;
    color: #64748b;
    margin: 0;
    font-weight: 400;
}

.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
}

.loading-content {
    text-align: center;
    max-width: 400px;
}

.loading-content h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1e293b;
    margin: 1rem 0 0.5rem;
}

.loading-content p {
    color: #64748b;
    margin: 0;
    line-height: 1.6;
}

/* Estilos para el mensaje de no dashboard */
.no-dashboard-message {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60vh;
}

.empty-state {
    text-align: center;
    max-width: 400px;
    padding: 2rem;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.empty-state h3 {
    color: #1e293b;
    margin: 1rem 0 0.5rem;
}

.empty-state p {
    color: #64748b;
    margin-bottom: 1.5rem;
}

.btn-refresh {
    background-color: #3b82f6;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
    margin: .2rem;
}

.btn-refresh:hover {
    background-color: #2563eb;
}

@media (max-width: 1200px) {
    .column-right {
        padding-left: 0px;
    }
}

@media (max-width: 768px) {
    .page-header {
        padding: 1.5rem;
    }

    .title-section {
        flex-direction: column;
        text-align: center;
        gap: 1rem;
    }

    .page-icon {
        width: 48px;
        height: 48px;
    }

    .page-title {
        font-size: 1.5rem;
    }

    .page-subtitle {
        font-size: 1rem;
    }
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
}

.modal-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 1.5rem;
}

.btn-refresh {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    font-weight: 500;
    transition: opacity 0.2s;
}

.btn-refresh:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.notion-toolbar {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;

    /* En pantallas medianas+ alinea en fila */
    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
    }
}

.notion-toolbar .btn-refresh {
    padding: 0.6rem 1.2rem;
    border: none;
    border-radius: 8px;
    font-size: 0.95rem;
    color: #fff;
    /* color del texto, el fondo lo define el inline style */
    font-weight: 500;
    cursor: pointer;
    transition: filter 0.2s ease;
}

.notion-toolbar .btn-refresh:hover {
    filter: brightness(0.9);
}

.search-container {
    flex: 1;
}

.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 0 0.5rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input-wrapper:focus-within {
    border-color: #a8a8a8;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}

/* .search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.4rem;
} */

.search-input {
    flex: 1;
    padding: 0.5rem 0;
    border: none;
    outline: none;
    font-size: 0.95rem;
    background: transparent;
    color: #333;
}

/* Sección principal */
.notion-section {
    margin-bottom: 2rem;
}

.section-title {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #333;
}

/* Grupo de botones */
.button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}

/* Reutilizamos btn-refresh definido antes */

/* Modal */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
}

.modal-content {
    background: #fff;
    border-radius: 12px;
    padding: 2rem;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    animation: fadeIn 0.25s ease-out;
}

.modal-title {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #333;
}

.modal-text {
    font-size: 0.95rem;
    color: #555;
    margin-bottom: 1rem;
}

.file-input {
    display: block;
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #f9f9f9;
    font-size: 0.9rem;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s;
}

/* .file-input:focus {
    outline:
} */

.notion-toolbar {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
    }
}

.search-container {
    flex: 1;
}

/* SELECT con look minimalista */
.select-input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background-color: #fff;
    font-size: 0.95rem;
    color: #333;
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg fill='none' height='20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M6 8l4 4 4-4' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 1rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.select-input:focus {
    outline: none;
    border-color: #a8a8a8;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}

/* Buscador (usa las clases previas) */
.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 0 0.5rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input-wrapper:focus-within {
    border-color: #a8a8a8;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.search-icon {
    margin-right: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-input {
    flex: 1;
    padding: 0.5rem 0;
    border: none;
    outline: none;
    font-size: 0.95rem;
    background: transparent;
    color: #333;
}
</style>